import { useEffect } from "react";
import { useSelector } from "react-redux";

import { RootState } from "store/rootReducer";
import { useMapStore } from "stores/map";

/**
 * Redux→Zustand relay for the child (popped-out) dashboard tab.
 *
 * `redux-state-sync` delivers parent-tab well-selection actions into Redux on
 * every change. This hook forwards those updates into Zustand so that
 * components reading `useSelectedWellFromStore` (Zustand-first) stay live in
 * the child tab without a map widget. See EVA-6684.
 */
export function useReduxSelectedWellsRelay(): void {
  const setSelectedWells = useMapStore((s) => s.setSelectedWells);
  const reduxSelectedWells = useSelector((state: RootState) => state.map.selectedWells);

  useEffect(() => {
    setSelectedWells(reduxSelectedWells ?? {});
  }, [reduxSelectedWells, setSelectedWells]);
}
